// Bewegungs-Konstanten (README §4.8). Eine Stelle für alle Dauern und Kurven.

/** cubic-bezier(.32,.72,0,1) – die „iOS“-Kurve des Designs. */
export const EASE_IOS = [0.32, 0.72, 0, 1] as const;
export const EASE_IOS_CSS = 'cubic-bezier(.32,.72,0,1)';

export const MOTION = {
  /** Widget → Panel: Position/Größe */
  morph: { duration: 0.5, ease: EASE_IOS },
  /** Inhalt im Panel: Einblenden verzögert */
  morphInhalt: { opacityDauer: 0.3, transformDauer: 0.45, verzoegerung: 0.14 },
  /** Nach dem Schließen wird der Panel-State geleert */
  morphSchliessenMs: 520,
  /** Raster beim Öffnen eines Panels */
  rasterAus: { opacity: 0, scale: 0.94, blurPx: 6 },
  /** Drehkarte */
  flip: { duration: 0.75, ease: EASE_IOS, perspektivePx: 1800 },
  /** Bereich einschieben (Einheit, Sidebar) */
  sideIn: { duration: 0.4, ease: EASE_IOS, versatzPx: 24 },
  /** Seitenwechsel per View Transition */
  seitenwechsel: { duration: 0.6 },
  /** iOS-Schalter */
  schalter: { duration: 0.25 },
  /** Toast-Anzeigedauer */
  toastMs: 2500,
} as const;

/** Respektiert „Bewegung reduzieren“. */
export function bewegungReduziert(): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
